export const LANG_OPTIONS: Record<string, string> = {
  "en-US": "English (US)",
  "es-ES": "Spanish (Spain)",
  "es-MX": "Spanish (Mexico)",
  "fr-FR": "French (France)",
  "vi-VN": "Vietnamese",
  "ar-SA": "Arabic (Saudi)",
  "zh-CN": "Chinese (Mandarin, Simplified)",
  "zh-TW": "Chinese (Mandarin, Traditional)",
  "zh-HK": "Chinese (Cantonese, Hong Kong)",
  "hi-IN": "Hindi (India)",
};
